<section class="header">
  <h2>{{ 'header.title' | translate }}</h2>
  <p>
    {{ 'header.description' | translate }}
  </p>

  <h3 class="current-step">{{ stepLabels[selectedIndex] | translate }}</h3>
</section>

<section class="transcriber-container">
  <mat-vertical-stepper
    [linear]="false"
    [selectedIndex]="selectedIndex"
    (selectionChange)="onStepHeaderChange($event)"
  >
    <ng-template matStepperIcon="edit">
      <mat-icon>check</mat-icon>
    </ng-template>

    <!-- Een geselecteerde stap krijgt van Material altijd de "number"-status, waardoor het
         vinkje van een afgeronde stap zou verdwijnen zodra je die stap selecteert. -->
    <ng-template matStepperIcon="number" let-index="index">
      @if (isStepCompleted(index)) {
        <mat-icon>check</mat-icon>
      } @else {
        <span>{{ index + 1 }}</span>
      }
    </ng-template>

    @for (label of stepLabels; track label; let i = $index) {
      <mat-step [completed]="isStepCompleted(i)">
        <ng-template matStepLabel>
          <span>{{ label | translate }}</span>
        </ng-template>
      </mat-step>
    }
  </mat-vertical-stepper>

  <div class="step-content">
    @if (!isResettingStep) {
      @switch (selectedIndex) {
        @case (0) {
          <app-transcriber-content
            [isSummaryUploadInProgress]="isSummaryUploadInProgress"
            [summaryUploadDone]="summaryUploadDone"
            (selectionChanged)="onTranscriberSelectionChanged($event)"
            (summaryGenerated)="onTranscriptSummarized()"
            (uploadSummaryToSsd)="uploadSummaryToSsd($event)"
          ></app-transcriber-content>
        }

        @case (1) {
          <app-action-plan
            [actionPlanFile]="actionPlanFile"
            [werkprocesNummer]="selectedWorkProcess?.werkprocesNummer ?? null"
            [clientNummer]="selectedWorkProcess?.clientNummer ?? null"
          ></app-action-plan>
        }

        @case (2) {
          <app-verify-action-plan
            [actionPlanVerdictError]="actionPlanVerdictError"
            [actionPlanVerdict]="actionPlanVerdict"
            [isVerifyInProgress]="isVerifyInProgress"
            (rerun)="rerunVerifyActionPlan()"
            [isUploadInProgress]="isUploadInProgress"
            [uploadDone]="uploadDone"
            [canUpload]="selectedWorkProcess != null"
            [preselectedWorkProcess]="selectedWorkProcess"
            (uploadToSsd)="uploadActionPlanToSsd()"
            (workProcessSelected)="onWorkProcessSelected($event)"
          ></app-verify-action-plan>
        }

        @case (3) {
          <app-product-suggestion
            [productSuggestionError]="productSuggestionError"
            [suggestedProducts]="productSuggestionResponse"
            [isProductSuggestionInProgress]="isProductSuggestionInProgress"
            [(selectedProducts)]="selectedProducts"
            (rerun)="rerunProductSuggestion()"
          ></app-product-suggestion>
        }

        @case (4) {
          <app-make-decision
            [(selectedProducts)]="selectedProducts"
            [werkprocesNummer]="selectedWorkProcess?.werkprocesNummer ?? null"
            [clientNummer]="selectedWorkProcess?.clientNummer ?? null"
          ></app-make-decision>
        }

        @case (5) {
          <app-check-decision
            [checkDecisionError]="checkDecisionError"
            [checkedDecisionText]="checkedDecisionOutput"
            [isCheckDecisionInProgress]="isCheckDecisionInProgress"
            [isUploadInProgress]="isDecisionUploadInProgress"
            [uploadDone]="decisionUploadDone"
            [canUpload]="selectedWorkProcess != null"
            [preselectedWorkProcess]="selectedWorkProcess"
            (rerun)="rerunCheckDecision()"
            (uploadToSsd)="uploadDecisionToSsd()"
            (workProcessSelected)="onWorkProcessSelected($event)"
          ></app-check-decision>
        }

        @case (6) {
          <app-document-summary
            [preselectedWorkProcess]="selectedWorkProcess"
            (summaryGenerated)="onSummaryGenerated()"
          ></app-document-summary>
        }

        @case (7) {
          <app-chat></app-chat>
        }
      }
    }
  </div>
</section>

<app-step-bar
  [labels]="stepLabels"
  [selectedIndex]="selectedIndex"
  [completed]="completedSteps()"
  (selected)="selectStep($event)"
></app-step-bar>
